import React from 'react';
import styles from './index.module.less';

const Loading = () => {
  return (
    <div className={styles.bouncingLoader}>
      <div />
      <div />
      <div />
    </div>
  );
};

export default Loading;
